import { YES_FLAG, NO_FLAG } from '../../shared/constants';

export const hideDecimalsFlagOptions = [
  {
    label: 'On',
    value: NO_FLAG,
  },
  {
    label: 'Off',
    value: YES_FLAG,
  },
];

export const negativeMinusFlagOptions = [
  {
    label: '-XX',
    value: YES_FLAG,
  },
  {
    label: '(XX)',
    value: NO_FLAG,
  },
];

export const displayZeroFlagOptions = [
  {
    label: '0',
    value: YES_FLAG,
  },
  {
    label: '-',
    value: NO_FLAG,
  },
];

export const shadeGridFlagOptions = [
  {
    label: 'On',
    value: YES_FLAG,
  },
  {
    label: 'Off',
    value: NO_FLAG,
  },
];
